<script setup lang="ts">
import BackendAPI from '@/BackendAPI'
import { computed, ComputedRef } from 'vue'
import { useInstanceStore } from '@/store/backendInstances'
import { useSettingsStore } from '@/store/settings'

const backendAPI: ComputedRef = computed(() => {
  return BackendAPI.getOrCreateBackendAPIInstance(useInstanceStore().selectedInstanceId || '66')
})

function disableDebugOutput() {
  useSettingsStore().disableQueueDebugOutput()
}
</script>

<template>
  <v-card style="z-index: 9999; position: fixed; top: 10px; left: 50%; transform: translateX(-50%); float: left; color: red">
    <v-card-title style="font-size: 13px">{{ backendAPI.globalUniqueIdentifier }}</v-card-title>
    <v-card-text style="font-size: 10px">
      {{ $t('queue_investigation.performing_quick_check', { value: backendAPI.currentlyPerformingQuickCheck }) }}
      <br />
      {{ $t('queue_investigation.performing_full_check', { value: backendAPI.currentlyPerformingFullCheck }) }}
      <br />
      {{ $t('queue_investigation.connection_strategy', { value: backendAPI.currentConnectionStrategy }) }}
      <br />
      {{ $t('queue_investigation.concurrent_requests', { value: backendAPI.accessibleState.concurrentRequests }) }}
      <br />
      {{ $t('queue_investigation.queue_length', { value: backendAPI.requestQueue.length }) }}
    </v-card-text>
    <v-card-actions>
      <v-btn
        size="x-small"
        @click="disableDebugOutput"
      >
        {{ $t('queue_investigation.disable') }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
